import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AppCardList } from '../../../../../common/components';
import { AppRoutes } from '../../../../../common/interfaces';
import { Hosting } from '../../../entities';

interface Props {
  currentPage: number;
  hostingsListItems: Hosting[];
  hostingsListTotalItems: number;
  hostingsListItemsPerPage: number;
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const HostingsListView: FC<Props> = ({
  currentPage,
  hostingsListItems,
  hostingsListTotalItems,
  hostingsListItemsPerPage,
  isLoading,
  handleChangePage
}) => {
  const navigate = useNavigate();
  const hostingId = useParams()['*'];

  return (
    <AppCardList<Hosting>
      headerTitle={ null }
      pagination={{
        current: currentPage,
        total: hostingsListTotalItems,
        pageSize: hostingsListItemsPerPage,
        disabled: isLoading,
        onChange: (page: number) => handleChangePage(page)
      }}
      selectedKey={ hostingId }
      rowKey="id"
      titleKey="name"
      grid={{
        gutter: 16,
        xs: 1,
        sm: 1,
        md: 1,
        lg: 2,
        xl: 2,
        xxl: 3
      }}
      navigateTo={ (record) => ({ to: AppRoutes.HostingsById.replace(':hostingId', record.id) }) }
      list={ hostingsListItems }
    />
  );
};
